import Vue from 'vue'
import Vuex from 'vuex'
import config from './modules/config.js'
import rk7ref from './modules/rk7ref.js'
import info from './modules/lic_info.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    url: process.env.NODE_ENV == 'development' ? 'http://127.0.0.1:11111' : ''
  },
  mutations: {
  },
  actions: {
    async doRequest(commit, income) {
      let endpoint = income['endpoint']
      let method = income['method']
      let data = income['body']

      let fetchOptions = {
          method: method,
          headers: {},
      }

      if (data != null) {
          fetchOptions.headers['content-type'] = 'application/json'
          fetchOptions.body = data
      }

      try {
          var r = await fetch(`${endpoint}`, fetchOptions)
      } catch (e) {
          console.error(e)
          throw e
      }

      if (r.status != 200) {
          if (r.status === 403 || r.status === 401) {
              console.error('Срок действия токена истёк');
              this.showSnack('Срок действия токена истёк', 'red');
              const rJson = await r.json();
              return { toAuth: true, status: r.status, response: rJson };
          } else {
              const rJson = await r.json();
              console.error(rJson);
              return { toAuth: false, status: r.status, response: rJson };
          }
      } else {
          if (r.headers.get('Content-Type') == 'application/json') {
              const rJson = await r.json();
              return { toAuth: false, status: r.status, response: rJson };
          } else {
              const rBlob = await r.blob()
              return { toAuth: false, status: r.status, response: rBlob };
          }
      }
  },

  },
  modules: {
    config,
    rk7ref,
    info
  }
})
